// extracted by extract-css-chunks-webpack-plugin
module.exports = {"deliveryNote":"AddressDisplayRow-56b52e65e4ad010c"};